export default "__VITE_ASSET__Dj7odJ6W__"